import { render } from "./StockWriteoffIcon.vue?vue&type=template&id=aaf5c58a"
import script from "./StockWriteoffIcon.vue?vue&type=script&lang=js"
export * from "./StockWriteoffIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__